import { render } from "./CajaChicaAdmin.vue?vue&type=template&id=389f3ffe"
import script from "./CajaChicaAdmin.vue?vue&type=script&lang=js"
export * from "./CajaChicaAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__